export default "__VITE_ASSET__D3wA0wqb__"